import { inject, InjectionToken } from '@angular/core';

/** Forms adaptation of Boards' existing native assistant-create intent. */
export interface FormStitchyCreateRequest {
  readonly formId: string;
  readonly space: string | null | undefined;
  readonly prompt: string;
}
export type FormStitchyCreate = (request: FormStitchyCreateRequest) => void;
export const FORM_STITCHY_CREATE = new InjectionToken<FormStitchyCreate>('FORM_STITCHY_CREATE');
export const STITCHY_CREATE_UNAVAILABLE = 'Create with Stitchy is not available here.';
export function injectFormStitchyCreate(): FormStitchyCreate | null {
  return inject(FORM_STITCHY_CREATE, { optional: true });
}
